import React from 'react';
import styles from './ViewPollDialog.module.css';

// Hooks
import { Dispatch, SetStateAction } from 'react';

// Components
import PollQuestions from '../../UI/PollQuestions/PollQuestions';

// Interfaces
import { Poll } from '../../../interfaces/Poll';

// Language
import { useTranslation } from 'react-i18next';

const ViewPollDialog: React.FC<{ 
    modalOpened: Dispatch<SetStateAction<boolean>>, 
    poll: Poll 
}> = ({ modalOpened, poll }) => {

    const { t } = useTranslation();

    const handleCloseDialog = () => modalOpened(false);

    return (
        <div className={`${styles.viewPollDialog} dialog`}>
            <div className={styles.pollContent}>
                <h1 className={styles.pollTitle}>{poll.name}</h1>
                <h2 className='dialogSubTitle'>{poll.description || ''}</h2>
                <div className={styles.questionsContainer}>
                    { poll.questions && <PollQuestions questions={poll.questions} />}
                </div>
            </div>
            <div className={styles.buttonWrapper}>
                <button onClick={handleCloseDialog}>{t('close')}</button>
            </div>
        </div>
    );
};

export default ViewPollDialog;